import React from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import S from './Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Offline() {
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsx("img", {
      className: S.locatorError,
      src: "https://recovr-ui-assets.storage.googleapis.com/locator-error.png",
      alt: "Locator warning",
      height: 136,
      width: 136
    }), /*#__PURE__*/_jsx(Text, {
      variant: "formTitle",
      children: "Locator Offline"
    }), /*#__PURE__*/_jsx(Text, {
      "data-cy": Config.get('cypress', ['text', 'locator.offline'], 'text.locator.offline'),
      children: "This Locator is offline and cannot be paired to a vehicle. Please select a new Locator to pair."
    })]
  });
}
Offline.TYPE = 'locatorOffline';